export interface IGeo {
  regionId: number;
  address: string;
  undergrounds: IUnderground[];
  title?: IGeoTitle | null;
}

export interface IUnderground {
  id: number;
  name: string;
  underConstruction: boolean;
  lineColor?: string | null;
  time?: string | null;
  transportType?: ETransportType | null;
  lineType?: string | null;
}

export enum ETransportType {
  Transport = 'transport',
  Walk = 'walk',
}

export interface IGeoTitle {
  name: string;
  link?: string;
}
